export enum PayoutOrderAutomationRequestOperation {
  CreatePayment = 'create_payment',
  ConfirmPayment = 'confirm_payment',
  PaymentStatus = 'payment_status',
}
